import { useBlockProps } from "@wordpress/block-editor"
import { ReactComponent as Badge } from "./listing-badge.svg";

export function ListingObject(props: { item: any }) {
  return (
    <div className="shadow-md flex flex-col h-full bg-white rounded-b-md">
      <div className="relative">
          {props.item.image &&
            <a href={props.item.link} className="relative block h-72 overflow-hidden">
              <img className="rounded-t-md object-cover absolute inset-0 h-full w-full hover:scale-110 transition-transform duration-500" loading="lazy" src={props.item.image.url} />
            </a>
          }

          {props.item.category.labelType &&
            <div className="absolute top-0 left-4">
              <div className="h-16 w-20">
                <Badge></Badge>
              </div>
              <div className="text-sm absolute bottom-1.5 inset-x-0 text-center text-white">{props.item.category.labelType}</div>
            </div>
          }

          {props.item.category.usageType &&
            <div className="absolute right-4 top-4 py-.5 px-2 text-sm bg-white text-primary-500 rounded">{props.item.category.usageType.label}</div>
          }

          {props.item.category &&
            <div className="absolute -bottom-1 left-4 py-1 px-4 text-sm bg-white text-primary-500 rounded-t">{props.item.category.name}</div>
          }
      </div>
      <div className="p-4">
          <p className="swt-text-subheading-2 mb-2 truncate"><a href={props.item.link}>{props.item.title}</a></p>
          <p className="flex items-center gap-2 mt-2 text-neutral-500">
              <i className="fa-solid fa-location-dot"></i> {props.item.location}
          </p>

          <div className="grid grid-cols-2 mt-7 mb-2 gap-y-4">
            {props.item.metaFields.map((metaField, k) => (
              <div key={k} className="flex gap-2 lg:gap-x-4 items-center">
                  <span className="rounded-[100%] bg-primary-300 w-8 h-8 leading-[32px] text-center font-sm text-primary-500">
                    <i className={metaField.icon}></i>
                  </span>
                  <div className="flex flex-col justify-items-center place-items-center">
                    <div className="font-bold text-lg">{metaField.value}</div>
                    <div>{metaField.label}</div>
                  </div>
              </div>
            ))}
          </div>
      </div>
      <div className="mt-auto px-4">
        <div className="border-t border-neutral-200 border-solid"></div>
        <div className="flex">
          <div className="flex basis-2/3 items-center text-2xl font-bold py-4">
            <span>{props.item.price.value}</span>
            <span className="ml-3 text-xl font-medium text-gray-500">{props.item.price.label}</span>
          </div>

          <div className="flex basis-1/3 justify-end items-center">
            <a href={props.item.link}
               className="wp-block-button__link swt-button-primary bg-primary-300 border-primary-300 text-primary-500 hover:text-white !py-1 !my-0">
                 Details
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

